import { enableProdMode, ErrorHandler, provideAppInitializer, inject, APP_ID, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule, appInit, getCompanyServiceFactory } from './app/app.module';
import { environment } from './environments/environment';
import { PlatformHttpService } from './app/common/http/service/platformhttp.service';
import { AuthService } from './app/common/auth/service/auth.service';
import { LoggedInGuard } from './app/common/auth/guards/loggedin.guard';
import { PlatformErrorHandler } from './app/common/PlatformErrorHandler';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { PlatformRequestInterceptor } from './app/providers/interceptors/platform-request.interceptor';
import { GatewayInterceptor } from './app/providers/interceptors/gateway.interceptor';
import { GatewayXsrfInterceptor } from './app/providers/interceptors/gateway-xsrf-token-extractor';
import { SpinnerInterceptor } from './app/providers/interceptors/spinner.interceptor';
import { CompanyService } from './app/providers/services/company.service';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';
import { RequestUtils } from './app/common/request-utils';
import { BrowserModule, bootstrapApplication, provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SharedModule } from './app/modules/shared/shared.module';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { IconModule } from './app/scss/icon/icon.module';
import { AppComponent } from './app/app.component';

let cookieConsentConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: 'not-set'
  },
  "position": "bottom",
  "theme": "classic",
  "palette": {
    "popup": {
      "background": "#f5f8fd",
      "text": "#6f8ba4",
      "link": "#3b566e"
    },
    "button": {
      "background": "rgb(241, 239, 255)",
      "text": "rgb(51, 122, 183)",
      "border": "transparent"
    }
  },
  type: 'info',
  revokeBtn: '<div class="cc-revoke {{classes}}">Prikaži opcije kolačića</div>',
  revokable: false,
  showLink: true,
  // dismissOnScroll: 20,
  dismissOnTimeout: 30,
  content: {
    message: 'Ova stranica koristi kolačiće, zbog unapređenja Vašeg korisničkog iskustva. Nastavkom istraživanja stranice, prihvatate upotrebu kolačića.',
    dismiss: 'Prihvatam!',
    deny: 'Odbijam',
    allow: 'Prihvatam',
    link: 'Saznajte više',
    href: '/info/privacy-policy',
  }
};

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
     bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, // needed for toastr
        HttpClientModule, AppRoutingModule, FormsModule, ReactiveFormsModule, MatSnackBarModule, AppRoutingModule, NgcCookieConsentModule.forRoot(cookieConsentConfig), SharedModule, SlickCarouselModule, IconModule),
        PlatformHttpService,
        AuthService,
        LoggedInGuard,
        { provide: ErrorHandler, useClass: PlatformErrorHandler },
        { provide: HTTP_INTERCEPTORS, useClass: PlatformRequestInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: GatewayInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: GatewayXsrfInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
        provideAppInitializer(() => {
            const initializerFn = (appInit)(inject(CompanyService), inject(NgcCookieConsentConfig));
            return initializerFn();
        }),
        { provide: APP_ID, useValue: 'shopServerApp' },
        { provide: 'currentEnvironment', useValue: environment },
        { provide: 'currentCompanyService', useFactory: getCompanyServiceFactory, deps: [CompanyService] },
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        provideAnimations(),
        provideClientHydration()
    ]
})
  .catch(err => console.error(err));
   });
